<template>
<article v-if="model" class="profile-container medium-header">
    <ImageViewer :images="getImageObjects()" :thumbnails="getImageObjects()" :placeholder="{}" />
    <section id="profileContent">
        <div class="header">
            <h1 class="profileHeader">{{ model.name }}</h1>
            <p class="subheader"> {{ model.year }}</p>
        </div>
        <div id="about">
            <div class="body summary textElement" v-html="model.description"></div>
        </div>
    </section>
</article>
</template>

<script>
import ImageViewer from '@/components/ImageViewer'

export default {
    name: "Profile",
    components: {
        ImageViewer
    },
    props: {
        model: Object
    },
    methods: {
        getImageObjects() {
            let images = [];
            if (this.model) {
                if(this.model.image) {
                    images.push({
                        src: `${this.$rootUrl()}${this.model.image}`,
                        title: `${this.model.image_attribution}`
                    });
                }
            }
            return images;
        },
    },
}
</script>